import Accordion from 'entities/Accordion'
import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { getAppName } from 'shared/helpers/getAppName'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'

export const TermsConditionsAccordion = () => {
  const interfaceConfig = useConfigStore().config?.interfaceConfig
  const updateInterface = useConfigStore().updateInterface
  const isCC = useGlobalStore().isCCSelected

  const [agbValue, setAgbValue] = useState('')
  const [dsvgoValue, setDsvgoValue] = useState('')

  useEffect(() => {
    const { agbText = '', dsvgoText = '' } = interfaceConfig?.[getAppName(isCC)] || {}
    setAgbValue(agbText)
    setDsvgoValue(dsvgoText)
  }, [isCC, interfaceConfig])

  const handleAgbBlur = () => {
    if (agbValue !== interfaceConfig?.[getAppName(isCC)]?.agbText) {
      updateInterface({ agbText: agbValue })
    }
  }

  const handleDsvgoBlur = () => {
    if (dsvgoValue !== interfaceConfig?.[getAppName(isCC)]?.dsvgoText) {
      updateInterface({ dsvgoText: dsvgoValue })
    }
  }

  return (
    <Accordion title='Terms & Conditions'>
      <Input
        fullWidth
        label='AGB'
        rowsAmount={20}
        value={agbValue}
        onChange={setAgbValue}
        onBlur={handleAgbBlur}
      />
      <br />
      <br />
      <Input
        fullWidth
        label='DSVGO'
        rowsAmount={20}
        value={dsvgoValue}
        onChange={setDsvgoValue}
        onBlur={handleDsvgoBlur}
      />
    </Accordion>
  )
}
